<template>
  <div class="row-box">
    <WrapperField
      v-for="(fieldValue, fieldName) in data"
      :key="fieldValue + fieldName"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: FieldGroup.SECURITY_EVIDENCE_DETAILS,
        })
      "
    />
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Step2',
  components: {
    WrapperField,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    FieldGroup,
    createDataField,
  }),
};
</script>
